export default class OperationalData {
    constructor(sog, stw, pwr, rpm, dailyFuelConsumption) {
        this.sog = sog,
            this.stw = stw,
            this.pwr = pwr,
            this.rpm = rpm,
            this.dailyFuelConsumption = dailyFuelConsumption
    }
}